import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { IonRouterOutlet } from '@ionic/angular'
import { LogEvent } from 'src/app/interfaces/log'
import { LogService } from 'src/app/services/log/log.service'
import { RouterService } from 'src/app/services/router/router.service'
import { calculateIsBackgroundColorDark } from 'src/utils/color'

/**
 * 콘텐츠 랜딩 헤더
 */
@Component({
  selector: 'content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
})
export class ContentHeaderComponent implements OnInit, OnChanges {
  constructor(
    private routerService: RouterService,
    private routerOutlet: IonRouterOutlet,
    private logService: LogService
  ) {}

  @Input() showLoginButton = true
  @Input() showDrawerButton = true
  @Input() showLogo = false
  @Input() type: 'landing' | 'default' = 'default'
  @Input() title: string | undefined
  @Input() backgroundColor: string | undefined
  @Input() onBackButton?: () => void
  isBackgroundColorDark = false
  hasPreviousUrl = true

  ngOnInit() {
    this.hasPreviousUrl = !!this.routerService.getPreviousUrl()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('backgroundColor')) {
      if (this.backgroundColor === undefined) {
        return
      }
      const calculateTimeout = setTimeout(() => {
        this.isBackgroundColorDark = calculateIsBackgroundColorDark('.header-container')
        clearTimeout(calculateTimeout)
      }, 10)
    }
  }

  onClickBackButton(): void {
    // 이전 페이지가 없을 경우 루트 페이지로 이동
    if (!this.hasPreviousUrl) {
      this.routerService.navigate('')
      return
    }
    if (this.onBackButton !== undefined) {
      this.onBackButton()
    } else {
      this.routerService.navigateBack(this.routerOutlet)
    }
  }

  onClickLogo(): void {
    this.logService.eventLogging(LogEvent.HEADER_LOGO_CLICKED, { from: location.pathname })
    this.routerService.navigate('')
  }
}
